/** Generic toasts. Feature-specific toasts live in features/*. */
const dictionary = {
  "en": {
    "success": "Success",
    "emailCopied": "Email Copied to clipboard!",
    "emailsCopied": "Emails Copied to clipboard!",
    "inviteUrlCopied": "Invite URL copied to clipboard",
    "sending": "Sending...",
    "mailSent": "A confirmation mail has been sent successfully.",
    "successMessage": "Success Message",
    "genericError": "Something went wrong. Please try again."
  },
  "de": {
    "success": "Erfolg",
    "emailCopied": "E-Mail in die Zwischenablage kopiert!",
    "emailsCopied": "E-Mails in die Zwischenablage kopiert!",
    "inviteUrlCopied": "Einladungs-URL in die Zwischenablage kopiert",
    "sending": "Wird gesendet...",
    "mailSent": "Eine Bestätigungsmail wurde erfolgreich gesendet.",
    "successMessage": "Erfolgsmeldung",
    "genericError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
  },
  "fi": {
    "success": "Onnistui",
    "emailCopied": "Sähköpostiosoite kopioitu leikepöydälle!",
    "emailsCopied": "Sähköpostiosoitteet kopioitu leikepöydälle!",
    "inviteUrlCopied": "Kutsulinkki kopioitu leikepöydälle",
    "sending": "Lähetetään...",
    "mailSent": "Vahvistusviesti on lähetetty.",
    "successMessage": "Onnistumisviesti",
    "genericError": "Jokin meni pieleen. Yritä uudelleen."
  }
};

export default dictionary;
